<template>
  <div class="max-w-lg">
    <slot />
  </div>
</template>
